import { LayerProxy } from "./LayerProxy.js";

export { GeoJsonProxy };

class GeoJsonProxy extends LayerProxy {

    static availableCrs = ["EPSG:3857", "EPSG:4326", "EPSG:3995", "EPSG:3031"];

    constructor(vefLayer) {
        super();

        Object.assign(this.events, {
            "click": [],
            "mouseover": [],
            "mouseout": []
        });

        this.vefLayer = vefLayer;
        this.clickedFeatures = [];
    }

    getClickedFeatures() {
        const response = {
            layer: this.vefLayer,
            data: {
                type: "FeatureCollection",
                features: this.clickedFeatures
            }
        };

        // add crs if available, so the popup can be rendered with proper coordinates
        if (("geoJSON" in this.vefLayer) && ("crs" in this.vefLayer.geoJSON)) {
            response.data.crs = this.vefLayer.geoJSON.crs;
        }

        // reset clicked features
        this.clickedFeatures = [];
        return response;
    }

    getFeatureStyle(feature) { }
    updateStyle(feature) { }
    bringToFront() { }
    bringToBack() { }
    clear() { }
    setData(geoJson) { }
    setLabel(feature, label) { }
    getGeoJson() { }
    startEditing(feature) { }
    stopEditing(feature) { }
    updateTooltips() { }
    setFeatureStyle(feature, style) { }
    getBounds() { }
}